// Spanish translation

const es = {
  "menu.sale_validation": "VALIDACIÓN DE VENTAS",
  "sale.state.draft": "Borrador",
  "sale.state.processing": "En proceso",
  "sale.state.succeeded": "Completado",
  "sale.state.failded": "Fallido",
  "sale.state.draft.message": "La venta está en borrador.",
  "sale.state.processing.message": "La venta se está procesando...",
  "sale.state.succeeded.message": "¡La venta fue confirmada exitosamente!",
  "sale.state.failded.message": "La venta ha fallado. Intenta nuevamente.", 
};

export default es;
